<template>
    <div class="slide">

        <go-back />

        <div class="next" @click="next">
            <img src="/assets/img/icon-arrow-right-blue.svg" />
        </div>

        <div class="slide-container">

            <div class="question bigger" v-if="personTwoExists && personOneIsWorking && personTwoIsWorking">
                At what age do you and {{ personTwo.name }} <span>expect to retire</span>?
            </div>

            <div class="question bigger" v-if="personTwoExists && !personOneIsWorking && personTwoIsWorking">
                At what age does {{ personTwo.name }} <span>expect to retire</span>?
            </div>

            <div class="question bigger" v-if="!personTwoExists || personTwoExists && personOneIsWorking && !personTwoIsWorking">
                At what age do you <span>expect to retire</span>?
            </div>

            <div class="answer answer-col answers-centered">

            <div class="row" v-if="personOneIsWorking">
                <div class="col-md-12">
                    <label class="label-slider">I would like to retire when I am&nbsp;<span>{{ personOneSlider }}</span></label>
                    <v-slider
                        v-model="personOneSlider"
                        class="align-center"
                        :max="max"
                        :min="minPersonOne"
                        hide-details
                        :track-color="sliderTrack"
                    >
                    </v-slider>
                </div>
            </div>

            <div class="row" v-if="personTwoIsWorking">
                <div class="col-md-12">
                    <label class="label-slider">{{ personTwo.name }} would like to retire when they are&nbsp;<span>{{ personTwoSlider }}</span></label>
                    <v-slider
                        v-model="personTwoSlider"
                        class="align-center"
                        :max="max"
                        :min="minPersonTwo"
                        hide-details
                        :track-color="sliderTrack"
                    >
                    </v-slider>
                </div>
            </div>

            </div>

        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GoBack from "./GoBack";
    export default {
        name: 'ExpectRetirement',
        components: {
            GoBack
        },
        created() {
            this.personOneSlider = this.personOne.retirement_age;
            this.minPersonOne = this.personOne.current_age;

            if (this.personTwoIsWorking) {
                this.personTwoSlider = this.personTwo.retirement_age;
                this.minPersonTwo = this.personTwo.current_age;
            }
        },
        methods: {
            next() {
                this.$store.commit('individuals/setPersonOneRetirementAge', this.personOneSlider);

                if (this.personTwoIsWorking) {
                    this.$store.commit('individuals/setPersonTwoRetirementAge', this.personTwoSlider);
                }

                this.$router.push({ name: 'IndividualAge' });
            }
        },
        data() {
            return {
                minPersonOne: 0,
                minPersonTwo: 0,
                max: 100,
                personOneSlider: 0,
                personTwoSlider: 0,
                range: [-20, 70],
                sliderTrack: '#e0e0e0'
            }
        },
        computed: {
            ...mapGetters('individuals', [
                'personOne',
                'personTwo',
                'personTwoExists',
                'personOneIsWorking',
                'personTwoIsWorking',
            ]),
        }
    }
</script>
